import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Button, colors, IconButton, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Delete } from "@material-ui/icons";
import { useStylesAutoBlack, useStylesLbl, useStylesTF, useStylesUiElemment } from "../../../../../St/Reports/UseStyle";
import { Autocomplete } from "@material-ui/lab";
import { stElemnt } from "../../../../../St/comps/cStyle";

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 350,
    },
}));

export default function InvoicesExpensesTable(props) {
    const {     expenseList, setExpenseList, AutoOptions,
        or,isOpenUpdate,gets,setConfirmDialog,
    } = props;
    const stylH = stElemnt.SubHPruch;

    const stylRo2 = {
        padding: "0px 0px",
        textAlign: "-webkit-center",
        margin: "0px",
        whiteSpace: "normal",
        BorderBottom: "solid 0.5px",
        borderColor: "gray",
        fontSize: 14,
        fontFamily: "Amiri-Regular",
        fontWeight: "bold",
        width: "270px",
        maxWidth: "270px",
        minWidth: "200px",
        color: "#000"
    }
    const stylRo = {
        BorderBottom: "solid 0.5px",
        //borderStyle: "solid",
        borderColor: "gray",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 14,
        color: "#000"
    }
    const handleFocus = (e) => e.target.select();
    const [rowItem, setRowItem] = useState({});

    const onRowDelete = async (rowdata) => {
        if (or.postput == "toPut" && !isOpenUpdate) return;
        var newData = expenseList.filter((obj) => obj.no !== rowdata.no);
        const newItems = newData.map((row, i) => {
            return {
                ...row,
                no: i,
            };
        });
        setExpenseList([...newItems]);
        setConfirmDialog(false);
    };
    const claslbl = useStylesLbl();
    const clasAo = useStylesAutoBlack();
    const clasTF = useStylesTF();  
    const handleOpenUpdate = (props, e, row) => {
        if (or.postput == "toPut" && !isOpenUpdate) return;

        var newDataAcc_no = expenseList.filter((obj) => obj.edit_acc_no === true);
        var newDataValue = expenseList.filter((obj) => obj.editValue === true);
        var newDataNotes = expenseList.filter((obj) => obj.editNotes === true);
        var newDataOmla = expenseList.filter((obj) => obj.editOmla === true);

        if (rowItem?.no != null) {
            if (rowItem.no == row.no) {
                if (newDataAcc_no.length != 0 && props !== "Expense_Acc_no") {
                    EnterChangeTtems("Expense_Acc_no", rowItem, row);
                    setRowItem({});
                }
                else if (newDataValue.length != 0 && props !== "Expense_value") {
                    EnterChangeTtems("Expense_value", rowItem, row);
                    setRowItem({});
                } else if (newDataNotes.length != 0 && props !== "Expense_Note") {
                    EnterChangeTtems("Expense_Note", rowItem, row);
                }
                else if (newDataOmla.length != 0 && props !== "omla") {
                    EnterChangeTtems("omla", rowItem, row);
                }
            }
            else {
                if (newDataAcc_no.length != 0 && props !== "Expense_Acc_no") {
                    EnterChangeTtems("Expense_Acc_no", rowItem, row);
                    setRowItem({});
                    
                }
                else if (newDataValue.length != 0 && props !== "Expense_value") {
                    EnterChangeTtems("Expense_value", rowItem, row);
                    setRowItem({});
                } else if (newDataNotes.length != 0 && props !== "Expense_Note") {
                    EnterChangeTtems("Expense_Note", rowItem, row);
                }
                else if (newDataOmla.length != 0 && props !== "omla") {
                    EnterChangeTtems("omla", rowItem, row);
                }
            }
        } else {
            if (props === "Expense_value") {
                e.preventDefault();
                setRowItem(row);
                const index = row?.no;
                const dataUpdate = [...expenseList];
                dataUpdate[index] = {
                    ...row,
                    editValue: true,
                };
                setExpenseList([...dataUpdate]);

            } 
           
            else if (props === "Expense_Acc_no") {

                e.preventDefault();
                let defAcc_no = { id: row.Expense_Acc_no, name: row.acc_name };
                setRowItem({ ...row, defAcc_no: defAcc_no, });
                const index = row?.no;
                const dataUpdate = [...expenseList];
                dataUpdate[index] = {
                    ...row,
                    edit_acc_no: true,
                };
                setExpenseList([...dataUpdate]);
            }
            else if (props === "omla") {

                e.preventDefault();
                let defOmla = gets?.omlats.find((obj) => obj.id === row.omla);
                setRowItem({ ...row, defOmla: defOmla, });
                const index = row?.no;
                const dataUpdate = [...expenseList];
                dataUpdate[index] = {
                    ...row,
                    editOmla: true,
                };
                setExpenseList([...dataUpdate]);
            }
            else if (props === "Expense_Note") {
                e.preventDefault();
                setRowItem({ ...row });
                const index = row?.no;
                const dataUpdate = [...expenseList];
                dataUpdate[index] = {
                    ...row,
                    editNotes: true,
                };
                setExpenseList([...dataUpdate]);
            }
         
       
        }

    };

    const MathChangIdataTtems = (prop, row) => (event) => {
        setRowItem({
            ...rowItem,
            [prop]: event.target.value,
        });
    };
    const EnterChangeTtems = (prop, rowItem, row) => {
        let i = {
            Expense_value: Number(rowItem.Expense_value),
            Expense_value_Bill: Number(rowItem.Expense_value_Bill),
            omlaval: Number(rowItem.omlaval),
        };
        const index = row?.no;
        const dataUpdate = [...expenseList];
        dataUpdate[index] = {
            ...rowItem,
            Expense_value: i.Expense_value,
            Expense_value_Bill: i.Expense_value_Bill,
            omlaval: i.omlaval,
            editOmla: false,
            edit_acc_no: false,
            editNotes: false,
            editValue: false,
        };
        
        setExpenseList([...dataUpdate]);
        setRowItem({});

    };


    const changAutoAcc_no = (row, newValue) => {
        const index = row?.no;
        const dataUpdate = [...expenseList];
        dataUpdate[index] = {
            ...row,
            acc_no: newValue.id,
            Expense_Acc_no: newValue.id,
            acc_name: newValue.name,
            name: newValue.name,
            edit_acc_no: false,
        };
        setExpenseList([...dataUpdate]);
        setRowItem({});

    };
    const changAutoOmla = (row, newValue) => {
        const index = row?.no;
        const dataUpdate = [...expenseList];
        dataUpdate[index] = {
            ...row,
            omla: newValue.id,
            omlaval: newValue.exchange,
            omlaName: newValue.name,
            exchange: newValue.exchange,
            editOmla: false,
        };
        setExpenseList([...dataUpdate]);
        setRowItem({});

    };

    const { t } = useTranslation(["forms"]);
    const classes = useStyles();
    return (
        <TableContainer component={Paper}
            style={{ minHeight: 300, }}>
            <Table className={classes.table} size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow
                        style={{
                            backgroundColor: colors.grey[700],
                            color: "#fff",
                            fontWeight: 800,
                            fontFamily: "Amiri-Regular",
                            fontSize: 15,
                            border: "solid 0.6px"
                        }}
                    >
                         <TableCell style={stylH} align="center">
                                {""}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {"كود الحساب"}
                            </TableCell>

                            <TableCell style={stylH} align="center">
                                {t("account-name")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {"التفاصيل"}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("amount")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("currency")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("exchange-rate")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {t("amount-in-invoice-currency")}
                            </TableCell>
                            <TableCell style={stylH} align="center">
                                {""}
                            </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {expenseList.map((row, i) => (
                        <TableRow key={row.no}
                            style={{
                                padding: "5px 0px",
                                textAlign: "-webkit-center",
                                margin: "0px",
                                whiteSpace: "nowrap",
                                color: "#000",
                                fontWeight: 800,
                                fontFamily: "Amiri-Regular",
                                fontSize: 15,
                                border: "solid 0.6px"
                            }}>
                            <TableCell style={stylRo} align="center" >{row.no + 1}</TableCell>
                            <TableCell style={stylRo} align="center" >{row.Expense_Acc_no}</TableCell>
                            <TableCell style={stylRo2} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("Expense_Acc_no", event, row)}>

                                {
                                    row?.edit_acc_no ? (
                                        <Autocomplete
                                            autoHighlight
                                            openOnFocus
                                            classes={clasAo}
                                            value={rowItem.defAcc_no}
                                            onFocus={handleFocus}
                                            onChange={(event, newValue) => {
                                                changAutoAcc_no(row, newValue);
                                            }}
                                            id="combo-box-demo"
                                            options={AutoOptions?.Accindex}
                                            getOptionLabel={(option) =>
                                                typeof option === "string" ? option : option.name
                                            }
                                            onBlur={(e) => EnterChangeTtems("Expense_Acc_no", rowItem, row)}
                                            disableClearable={true}
                                            style={{ backgroundColor: colors.blue[50] }}
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={""}
                                                    variant="outlined"
                                                    InputLabelProps={{ className: claslbl.clrSafe }}
                                                />
                                            )}

                                        />
                                    ) :
                                        (
                                            row?.acc_name
                                        )

                                }

                            </TableCell>
                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("Expense_Note", event, row)}>
                                {
                                    row.editDept && row.credit == 0 ?
                                        (
                                            <>
                                                <TextField fullWidth
                                                    variant="outlined" size="small"
                                                    id="Expense_Note"
                                                    className={clasTF.rootSafe}
                                                    style={{ backgroundColor: colors.grey[50] }}
                                                    type="text"
                                                    name="Expense_Note"
                                                    onBlur={(e) => EnterChangeTtems("Expense_Note", rowItem, row)}
                                                    value={rowItem.Expense_Note}
                                                    onChange={MathChangIdataTtems("Expense_Note", row)}
                                                    autoFocus={true}
                                                    onFocus={handleFocus}
                                                    InputProps={{
                                                        className: claslbl.clrSafe,
                                                        onKeyDown: (event) => {
                                                            if (event.key === 'Enter') {
                                                                EnterChangeTtems("Expense_Note", rowItem, row);
                                                            }
                                                        },
                                                        onBlur: () => {
                                                            EnterChangeTtems("Expense_Note", rowItem, row);
                                                        },
                                                    }}
                                                />

                                            </>

                                        ) : (
                                            row.Expense_Note
                                        )}
                            </TableCell>

                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("Expense_value", event, row)}>

                                {
                                    row.editValue?
                                        (
                                            <>
                                                <TextField fullWidth
                                                    variant="outlined" size="small"
                                                    id="editValue"
                                                    className={clasTF.rootSafe}
                                                    style={{ backgroundColor: colors.grey[50] }}
                                                    type="number"
                                                    name="Expense_value"
                                                    onBlur={(e) => EnterChangeTtems("Expense_value", rowItem, row)}
                                                    value={rowItem.Expense_value}
                                                    onChange={MathChangIdataTtems("Expense_value", row)}
                                                    autoFocus={true}
                                                    onFocus={handleFocus}
                                                    InputProps={{
                                                        className: claslbl.clrSafe,
                                                        onKeyDown: (event) => {
                                                            if (event.key === 'Enter') {
                                                                EnterChangeTtems("Expense_value", rowItem, row);
                                                            }
                                                        },
                                                        onBlur: () => {
                                                            EnterChangeTtems("Expense_value", rowItem, row);
                                                        },
                                                    }}
                                                />

                                            </>

                                        ) : (
                                            parseFloat(row.Expense_value)?.toFixed(2)
                                        )}
                            </TableCell>

                            
                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("omla", event, row)}>

                                {
                                    row?.editOmla && gets?.omlats.length > 0 ? (
                                        <Autocomplete
                                            autoHighlight
                                            openOnFocuss
                                            classes={clasAo}
                                            value={rowItem.defOmla}
                                            onFocus={handleFocus}
                                            onChange={(event, newValue) => {
                                                changAutoOmla(row, newValue);
                                            }}
                                            id="combo-box-demo"
                                            options={gets?.omlats}
                                            getOptionLabel={(option) =>
                                                typeof option === "string" ? option : option.name
                                            }
                                            onBlur={(e) => EnterChangeTtems("omla", rowItem, row)}
                                            disableClearable={true}
                                            style={{ backgroundColor: colors.green[50] }}
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={""}
                                                    variant="outlined"
                                                    InputLabelProps={{ className: claslbl.clrSafe }}
                                                />
                                            )}

                                        />
                                    ) :
                                        (
                                            row?.omlaName
                                        )

                                }

                            </TableCell>
                            <TableCell style={stylRo} align="center">
                                {(Number(row.exchange)).toFixed(2)}</TableCell>
                                <TableCell style={stylRo} align="center">
                                    {(Number(row.Expense_value) * Number(row.omlaval)).toFixed(2)}</TableCell>

                         
                            <TableCell style={stylRo} align="center" >
                                <IconButton
                                    color="primary"
                                    aria-label="upload picture"
                                    style={{ maxHeight: "0.7rem" }}
                                    onClick={(e) => {
                                        if (or.postput == "toPut" && !isOpenUpdate) {

                                        } else {
                                            setConfirmDialog({
                                                isOpen: true,
                                                onConfirm: () => {
                                                    onRowDelete(row);
                                                },
                                            })
                                        }
                                    }}
                                >
                                    <Delete size={"small"} />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
